const desingersChanger = () => {
    
    //variables
    const designButtons = document.querySelectorAll('[data-design-button]');
    const heroSlides = document.querySelectorAll('.section-hero__slide');
    const decisionsSlides = document.querySelectorAll('.page-slides__slide');
    // const heroSlidesWrapper = document.querySelector('[data-hero-slides-wrapper]');
    // const pagesSlidesWrapper = document.querySelector('[data-page-slides-wrapper]');
    // let wrapperTransformValue;

    //set click to all btns for changing page content
    for (let i = 0; i < designButtons.length; i++) {
        designButtons[i].addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            //deleting active class from all buttons
            for (const db of designButtons) {
                if (db.classList.contains('active')) {
                    db.classList.remove('active');
                }
            }

            //transform value for slides wrapper (item number * 100%)
            // wrapperTransformValue = i * 100;

            requestAnimationFrame(() => {
                //close the others slides
                for (let slide of heroSlides) {
                    slide.classList.add('dn');
                    slide.classList.remove('active');
                }
                for (let slide of decisionsSlides) {
                    slide.classList.add('dn');
                    slide.classList.remove('active');
                }

                //adding active class for event target button
                designButtons[i].classList.add('active');

                //open current slide
                heroSlides[i].classList.remove('dn');
                decisionsSlides[i].classList.remove('dn');
                setTimeout(() => {
                    heroSlides[i].classList.add('active');
                    decisionsSlides[i].classList.add('active');
                }, 1);
                // heroSlidesWrapper.style.transform = `translateX(-${wrapperTransformValue}%)`
                // pagesSlidesWrapper.style.transform = `translateX(-${wrapperTransformValue}%)`
            });
        });
    }

}

export {desingersChanger};